module.exports = __webpack_public_path__ + "img/22.28971814.jpg";